import { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';

// import Button from '@mui/material/Button';

import ActiveClasses from './ActiveClasses/ActiveClasses';
import ArchiveClasses from './ArchiveClasses/ArchiveClasses';
import TabsContainer from './TabsContainer/TabsContainer';
import Loading from 'uI/Loading/Loading';

import { getUserClassrooms, userStatus } from 'store/udc-actions';

// import classes from './UDCClasses.module.css';

const UDCClasses = () => {
  const [value, setValue] = useState(0);
  const [load, setLoad] = useState(true);
  const [classrooms, setClassrooms] = useState([]);
  const [status, setStatus] = useState([]);
  console.log('🚀 ~ UDCClasses ~ classrooms:', classrooms);

  useEffect(() => {
    (async () => {
      setClassrooms(
        await getUserClassrooms('103798424558400031505')
      );
      setStatus(await userStatus());
    })();
  }, []);

  useEffect(() => {
    if (classrooms.section) {
      setLoad(false);
    }
  }, [classrooms]);

  const changeSectionHandler = section => {
    setValue(section);
  };

  return (
    <>
      {!load ? (
        <>
          <TabsContainer changeSection={changeSectionHandler} />
          {value === 0 && (
            <ActiveClasses status={status} classrooms={classrooms} />
          )}
          {value === 6 && (
            <ArchiveClasses
              status={status}
              classrooms={classrooms}
            />
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default UDCClasses;
